import { render, staticRenderFns } from "./DirectCostsBreakdown.vue?vue&type=template&id=4c3d2a02"
import script from "./DirectCostsBreakdown.vue?vue&type=script&lang=js"
export * from "./DirectCostsBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports